import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = (url, data = {}) => window.axios.delete(url, { data, baseURL });
const _get = url => window.axios.get(url, { baseURL });
const _patch = (url, params) => window.axios.patch(url, params, { baseURL });

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return _get(`/comments/manage?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setComments", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getComment(context, id) {
    return new Promise((resolve, reject) => {
      return _get(`/comments/manage/${id}`)
        .then(results => {
          resolve(results.data);
        })
        .catch(reject);
    });
  },
  like(context, id) {
    return new Promise((resolve, reject) => {
      _post("/comments/like/" + id)
        .then(resolve)
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/comments/manage`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  update(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/comments/manage/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  remove(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/comments/manage/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  updateMany(context, params) {
    return new Promise((resolve, reject) => {
      _patch(`/comments/manage`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteMany(context, params) {
    return new Promise((resolve, reject) => {
      _delete(`/comments/manage`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  postModeratorProfile(context, data) {
    return new Promise((resolve, reject) => {
      _post(`/comments/moderators/`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  putModeratorProfile(context, data) {
    const code = data.code;
    delete data.code;
    return new Promise((resolve, reject) => {
      _put(`/comments/moderators/${code}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getModeratorProfiles(context, product_id) {
    return new Promise((resolve, reject) => {
      _get(`/comments/moderators/${product_id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
